module.exports = __webpack_public_path__ + "static/media/viamais_pin.8c8d0f7d.png";